<template>
<div class="creature-block">
  <hr class="orange-border" />
  <creature-header :name="name" :level="level" :role="role" :detail="detail" :type="type"  />

  <tapered-rule />

  <creature-statistics
    :attackBonus="attackBonus"
    :armorClass="armorClass"
    :hitPoints="hitPoints"
    :damage="damage"
    :savingThrows="savingThrows"
    :spellDC="spellDC"
    :initiative="initiative"
    :perception="perception"
    :speed="speed"
    :stealth="stealth"
    :abilityModifiers="abilityModifiers"
    :type="type"
  />

  <tapered-rule />

  <trait-list :traits="[...traits, ...powers]" :damage="damage" :type="type"/>

  <hr class="orange-border bottom" />
</div>
</template>

<script>
import TaperedRule from './tapered-rule.vue';
import CreatureHeader from './creature-header.vue';
import CreatureStatistics from './creature-statistics.vue';
import TraitList from './trait-list.vue';

import paramGrow from '../data/param-grow.json';
import roleData from '../data/roles.json';
import typeData from '../data/types.json';

export default {
  props: {
    name: String,
    detail: String,
    level: Number,
    role: String,
    type: String,
    traits: Array,
    powers: Array,
    players: Number
  },
  computed: {
    proficiency() {
      let proficiencyBonus = paramGrow[this.level + 3]['proficiencyBonus'];
      return proficiencyBonus;
    },
    speed() {
      let speed = 30;
      speed += roleData[this.role]['speed'];
      return speed;
    },
    attackBonus() {
      let attackBonus = paramGrow[this.level + 3]['attackBonus'];
      attackBonus += roleData[this.role]['attackBonus'] + typeData[this.type]['attackBonus'];
      return attackBonus;
    },
    spellDC() {
      let spellDC = paramGrow[this.level + 3]['spellDC'];
      spellDC += roleData[this.role]['attackBonus'] + typeData[this.type]['spellDC'];
      return spellDC;
    },
    armorClass() {
      let armorClass = paramGrow[this.level + 3]['armorClass'];
      armorClass += roleData[this.role]['armorClass'] + typeData[this.type]['armorClass'];
      return armorClass;
    },
    hitPoints() {
      let hitPoints = paramGrow[this.level + 3]['hitPoints'];

      if(this.type == 'solo') {
        hitPoints = Math.floor(hitPoints * roleData[this.role]['hitPoints'] * this.players);
      } else {
        hitPoints = Math.floor(hitPoints * roleData[this.role]['hitPoints'] * typeData[this.type]['hitPoints']);
      }

      return hitPoints;
    },
    damage() {
      let damage = paramGrow[this.level + 3]['damage'];
      damage = Math.floor(damage * roleData[this.role]['damage'] * typeData[this.type]['damage']);
      return damage;
    },
    perception() {
      let perception = paramGrow[this.level + 3]['abilityBase'];
      perception += typeData[this.type]['perception'];
      return roleData[this.role]['perception'] ? perception + this.proficiency : perception;
    },
    stealth() {
      let stealth = paramGrow[this.level + 3]['abilityBase'];
      stealth += typeData[this.type]['stealth'];
      return roleData[this.role]['stealth'] ? stealth + this.proficiency : stealth;
    },
    initiative() {
      let initiative = paramGrow[this.level + 3]['abilityBase'];
      initiative += typeData[this.type]['initiative'];
      return roleData[this.role]['initiative'] ? initiative + this.proficiency : initiative;
    },
    abilityModifiers() {
      let modifiers = paramGrow[this.level + 3]['abilityModifiers'];
      return modifiers;
    },
    savingThrows() {
      let throws = paramGrow[this.level + 3]['savingThrows'];
      return throws.map(save => save + typeData[this.type]['savingThrows']);
    }
  },
  components: {
    TaperedRule,
    CreatureHeader,
    CreatureStatistics,
    TraitList
  }
}
</script>

<style lang="scss">
.creature-block {
  text-align: left;
  margin: 20px;
  display: inline-block;
  vertical-align: top;
  width: 300px;
  background: #FDF1DC;
  padding: 5px 10px;
  box-shadow: 0 0 1.5em #867453;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;

  .orange-border {
    display: block;
    background: #E69A28;
    border: 1px solid #000;
    height: 5px;
    padding: 0 10px 0;
    margin: -10px -10px 10px;
    box-sizing: initial;

    &.bottom {
      margin: 15px -10px -10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/creature-block.vue